export default {
  mainTitle: {
    en: 'Rate & Review',
  },

  titleLabel: {
    en: 'Title',
  },
  reviewLabel: {
    en: 'Review',
  },

  reviewPlaceholder: {
    // eslint-disable-next-line
    en: 'Write your impression about this product. Did you enjoy the scent or texture? Does it remind you of something? What notes stand out? Did it last? What occasion or season would you use it for? Try to be as specific as possible to get a high rating and help other people choose the right product',
  },

  makeupReviewPlaceholder: {
    // eslint-disable-next-line
    en: 'Write your review here... Do you enjoy using this product - why or why not? How would you describe the texture, pigment and payoff of this product? Did this product meet your expectations - why or why not? Would you recommend this product?',
  },

  hint: {
    en: 'This optional information helps make your review more useful to other customers and receive a personalized recommendation.',
  },

  submitButtonTitle: {
    en: 'Submit review',
  },
}
